import { c as _c } from "react/compiler-runtime";
import { KeyValueGrid } from "@/components/domain/key-value-grid";
import { KeyValueSkeletonList } from "@/components/domain/key-value-skeleton";
import { ReportSection } from "@/components/domain/report-section";
import { sections } from "@/lib/constants/sections";
export function HeadersSectionSkeleton() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ReportSection isLoading={true} {...sections.headers}><KeyValueGrid colsDesktop={2}><KeyValueSkeletonList count={12} widthClass="w-[180px]" withTrailing={true} /></KeyValueGrid></ReportSection>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}